import { UserInfo } from './user';

export type Message = {
  messageId: string;
  text: string;
  createdAt: Date;
  user: UserInfo;
};

export type Chat = {
  chatId: string;
  userIds: string[];
  userDocs: UserInfo[];
  createdAt: Date;
  updatedAt: Date;
  createdBy: string;
  unreadMessageCount: Record<string, number>;
  latestMessage?: Message;
};
